import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button,  Breadcrumb, Form, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { columns, data } from '../data/data_m';
import moment from 'moment';
import { DeleteStudents, GetStudent } from '../../utils/axios/StudentAPI';
import { Decrypt } from '../../utils/Helper';
import { TimerAlert, ConfirmAlert, getRoles } from '../../utils/swtAlert';
import { GrokLoading } from "../page-layout/loading/Loading";

const Student = () => {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [data, setData] = useState();
    const [Name, setName] = useState("");
    const handleName = (e) => {
        setName(e.target.value)
    }

    
    const columns = [
        {
          name: "Name",
          selector:  row => row.DisplayName,
          sortable:true,
          cell: row => row.DisplayName,
        },
        {
          name: "Gender",
          selector:  row => row.Gender.name,
          sortable:true,
          cell: row => row.Gender.name,
        },
        {
          name: "Branch",
          selector: row => row.Branch.name,
          sortable: true,
          cell: row => row.Branch.name,
        },
        {
          name: "Year",
          width: "160px",
          selector: row => row.Year.name,
          sortable: true,
          cell: row => row.Year.name,
        },
        {
          name: "Semester",
          width: "160px",
          selector: row => row.Semester.name,
          sortable: true,
          cell: row => row.Semester.name,
        },
        {
          name: "Email",
          width: "230px",
          selector: row => row.Email,
          sortable: true,
          cell: row => row.Email,
        },
        {
          name: "Contact Number",
          width: "170px",
          selector: row => row.MobileNumber,
          sortable: true,
          cell: row => row.MobileNumber,
        },
        {
            name: "Actions",
            width: "200px",
            cell: (row) => (<>
                <button className="btn btn-link ms-1" title="Edit" onClick={() => handleStudentEdit(row._id)} ><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>
                <button className="btn btn-link ms-1" title="Delete" onClick={() => handleStudentDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role !== "college") ? true : false
        },
      ];
      
    const tableData = {
      columns,
      data,
    };

    const addStudents = () => {
      navigate('/participantdetails',  {state: {studentsid: null} });
    }
      
    const handleStudentEdit = (id) => {
        navigate('/participantdetails', {state: {studentsid: id} });
    }
    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', {state: {studentsid: null}});
    }

    const handleStudentDelete = async (id) => {
        ConfirmAlert("You want to Delete Student!", 'Are you sure?', 'warning', 'Yes, delete this Student!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await DeleteStudents(id);
                    if (response) {
                        TimerAlert("success", "Student Deleted Successfully", "success");
                        getStudents();
                    }
                }
            }
        )
    }

    const getStudents = async () => {
        let studentPayload = {
            OrganizationId: userInfo.OrganizationId,
            IsGrovatorLab: true,
        }
        var studentResponse = await GetStudent(studentPayload);
        setData(studentResponse.data);
        setLoading(false);
    }

    useEffect(() => {
        getStudents();
        const role = getRoles(userInfo);
        setRole(role);
        document.querySelectorAll(".navbar-nav .nav-item a")[1].classList.add("active")
    }, [])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item  onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Participants</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Participants'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 640 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Participants</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3 mt-3'>
                        <div className='card mb-3 mb-lg-5 '> 
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <div className="form-group position-relative">
                                            <form className="d-flex mb-2 mb-md-0">
                                                <div className="form-group position-relative">
                                                    <input className="form-control leftpadding" id="text" variant="outlined" placeholder='Students Name' onChange={handleName} />
                                                </div>
                                            </form>
                                        </div> */}
                                    </Col>
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <Button variant="white" onClick={handleShow} >
                                            <span className='me-2'><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1.15em" width="1.15em" xmlns="http://www.w3.org/2000/svg"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"></path><path d="M4 6v8m5.009 .783c.924 .14 1.933 .217 2.991 .217c4.418 0 8 -1.343 8 -3v-6"></path><path d="M11.252 20.987c.246 .009 .496 .013 .748 .013c4.418 0 8 -1.343 8 -3v-6m-18 7h7m-3 -3l3 3l-3 3"></path></svg></span>
                                                Import Student 
                                        </Button> */}
                                    </Col>
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <button className="backBtn_style" onClick={() => addStudents()} >
                                            New Student
                                        </button> */}
                                    </Col>

                                </Row>
                                {/* End Row */}
                            </div>
                            <div>
                                <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                                {loading ? <GrokLoading /> : ""}
                                <Modal.Header closeButton>
                                    <Modal.Title><b>Upload Participants Data</b> </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                        <Row className="align-items-center">
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label> Participants data</Form.Label>
                                                    <div className="col">
                                                        <Form.Control type="file" />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Row>
                                    <Col>
                                        <Button variant="secondary" type="button" size="sm" onClick={handleClose}>Cancel</Button>
                                    </Col>
                                    <Col className="col-md-auto">
                                        <Button variant="primary" color="primary" size="sm"> Upload</Button>
                                    </Col>
                                    </Row>
                                </Modal.Footer>
                                </Modal>
                            </div>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default Student; 